/**
 * Cross-Device Sync Module
 * Handles passkey sync and device management
 */

export { VaultSync } from './vault';
export { DeviceManager } from './device-manager';
export { PlatformDetector } from './platform-detect';

export * from './types';
